import React from 'react';
import Grid from '@mui/material/Grid2'
import './ApprovedCheckbox.css';
class ApprovedCheckbox extends React.Component {
	componentDidMount() {
    const { id, checked } = this.props;
		const checkbox = document.getElementById(id);
		if (checkbox && checked) checkbox.checked = true;
  }
		componentDidUpdate(prevProps) {
		const { id, checked } = this.props;
		const checkbox = document.getElementById(id);
		if (checkbox && checked !== prevProps.checked) checkbox.checked = checked;
  }
  render() {
    const { checked, onChange, name, id, label } = this.props;
	  return (
		<Grid size={3} className='ml-3'>
      <label className="custom-checkbox">
        <input
          type="checkbox"
          checked={checked}
          onChange={onChange}
          name={name}
          id={id}
        />
        <span className="checkmark"></span>
        {label}
      </label>
		</Grid>
    );
  }
}
export default ApprovedCheckbox;
